import { HttpHeaders } from '@angular/common/http';
import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AuthenticationStateService } from '@quorum/authentication/services';
import { ServiceLaneFacade } from '@quorum/service-lane-root/facade';
import { SystemControlStateService } from '@quorum/xsr-system-control/services';
import { OemIntegrationService } from 'libs/quorum-api/src/lib/oem-integration.service';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap, take, tap } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';

@Component({
  selector: 'svc-hyundai-dashboard',
  templateUrl: './hyundai-dashboard.component.html',
  styleUrls: ['./hyundai-dashboard.component.scss'],
})
export class HyundaiDashboardComponent implements OnInit, OnChanges {
  vehicleInfoUi: any = { collapsed: false };
  recallsUi: any = { collapsed: true };
  warrantyUi: any = { collapsed: true };
  openRecallsOrCampaignsOrErrorsExist: any;
  hyundaiIntegrationEnabled$: Observable<string>;
  @Input() collapsed: boolean;
  constructor(
    public serviceLaneFacade: ServiceLaneFacade,
    private oemIntegrationService: OemIntegrationService,
    private authenticationStateService: AuthenticationStateService,
    private systemControlStateService: SystemControlStateService,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.hyundaiIntegrationEnabled$ = this.authenticationStateService.selectAuthenticatedEmployee().pipe(
      filter((emp) => emp != null),
      take(1),
      switchMap((employee) => {
        return this.systemControlStateService
          .getSystemControlValues(['CL_HYUNDAI_INTEGRATION_ENABLED'], employee.rooftopId)
          .pipe(
            take(1),
            map((scts) => {
              return scts['CL_HYUNDAI_INTEGRATION_ENABLED'].value;
            })
          );
      })
    );
    this.serviceLaneFacade.hyundaiDashboardData$
      .pipe(
        take(1),
        tap((dashboardData: any) => {
          console.log(dashboardData);
          if (dashboardData?.dashboard?.recallCampaigns) {
            dashboardData?.dashboard?.recallCampaigns.forEach((recall: any) => {
              if (!recall.RepairStatus) {
                this.openRecallsOrCampaignsOrErrorsExist = true;
              }
            });
          }

          if (dashboardData?.dashboard?.serviceCampaigns) {
            dashboardData?.dashboard?.serviceCampaigns.forEach((serviceCampaign: any) => {
              if (!serviceCampaign.RepairStatus) {
                this.openRecallsOrCampaignsOrErrorsExist = true;
              }
            });
          }

          if (dashboardData?.dashboard?.recallCampaignError || dashboardData?.dashboard?.serviceCampaignError) {
            this.openRecallsOrCampaignsOrErrorsExist = true;
          }
        })
      )
      .subscribe();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.collapsed) {
      if (changes.collapsed.currentValue) {
        this.vehicleInfoUi.collapsed = changes.collapsed.firstChange ? false : true;
        this.recallsUi.collapsed = true;
        this.warrantyUi.collapsed = true;
      } else {
        this.vehicleInfoUi.collapsed = false;
        this.recallsUi.collapsed = false;
        this.warrantyUi.collapsed = false;
      }
    }
  }

  toggleCollapse(groupUiObject: any) {
    groupUiObject.collapsed = !groupUiObject.collapsed;
  }

  isArray(array: any[]) {
    return Array.isArray(array);
  }

  downloadRecallDocument(recallDoc: any) {
    let toastOptions: any = {
      message: `Downloading file...`,
      actionText: null,
      options: { duration: 3000 },
    };
    this.serviceLaneFacade.addToast(toastOptions);

    this.oemIntegrationService
      .get(`hyundai/documents/customer-letter/${recallDoc.Id}/${recallDoc.FileGUID}/download-file`, {
        responseType: 'blob',
      })
      .pipe(
        catchError((error: any) => {
          console.log(error);
          return of(error);
        })
      )
      .subscribe((doc) => {
        // chrome on ios
        if (this.platform.WEBKIT === true && this.platform.IOS === true && this.platform.SAFARI === true) {
          var file = new Blob([doc], { type: 'application/pdf' });
          var fileURL = URL.createObjectURL(file);
          var win = window.open();
          win.document.write(
            '<iframe src="' +
              fileURL +
              '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
          );
        } else {
          const url = URL.createObjectURL(new Blob([doc]));
          const a: any = document.createElement('a');
          a.href = url;
          a.download = recallDoc.FileName;
          document.body.appendChild(a);
          a.style = 'display: none';
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        }
      });
  }

  isObject(value: any): boolean {
    return typeof value === 'object';
  }
}
